import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import RichTextField from '@ts-core/components/RichTextField';
import Button from '@ts-core/components/Button';

import { useTextField } from '@ts-core/hooks/ui';

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(2),
  },
}));

const ThreadForm = (props) => {
  const classes = useStyles();
  const { thread, submitting, onSubmit } = props;
  const [isFormBusy, setIsFormBusy] = useState(false);

  const nameField = useTextField(thread.title);
  const { value: title } = nameField;

  const [content, setContent] = useState(thread.content);

  const handleOnSubmit = useCallback(() => {
    onSubmit({ title, content });
  }, [onSubmit, title, content]);

  return (
    <Box width="100%">
      <TextField
        label={<FormattedMessage id="forum.postTitle" defaultMessage="Título" />}
        className={classes.title}
        fullWidth
        variant="outlined"
        {...nameField}
      />
      <RichTextField value={content} onChange={setContent} onBusyStatsChange={setIsFormBusy} />
      <Box mt={2} width="100%" display="flex" justifyContent="flex-end">
        <Button loading={submitting} disabled={!title || !content || isFormBusy} color="primary" onClick={handleOnSubmit}>
          <FormattedMessage id="forum.form.submitButton" defaultMessage="Enviar" />
        </Button>
      </Box>
    </Box>
  );
};

ThreadForm.propTypes = {
  thread: PropTypes.object,
  submitting: PropTypes.bool,

  onSubmit: PropTypes.func,
};

ThreadForm.defaultProps = {
  thread: {},
  submitting: false,

  onSubmit() {},
};

export default ThreadForm;
